import Dialog from '@mui/material/Dialog';
import { useEffect, useState } from 'react';
import { webAssetUrl } from 'lib/utils/imageUtils';

interface Props {
  loading: boolean;
  textArray: string[];
}

export const LoadingAnimation = ({ loading, textArray }: Props) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (textArray.length > 1) {
      const interval = setInterval(() => {
        if (index >= textArray.length - 1) {
          setIndex(0);
        } else {
          setIndex(index + 1);
        }
      }, 2500);

      return (() => clearInterval(interval));
    }
    return () => {};
  });

  useEffect(() => {
    setIndex(0);
  }, [loading]);

  return (
    <Dialog
      open={loading}
      maxWidth="xs"
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
    >
      <div className="text-center text-xl">
        <img src={webAssetUrl('loading.gif')} alt="loading" className="m-auto w-1/4 rounded-full mb-4" />
        <p className="rounded-full m-auto text-white font-bold">
          <span key={index} className="animate-word">
            {textArray[index]}
          </span>
        </p>
      </div>
    </Dialog>
  );
};
